import React from 'react'
import {
    Drawer,
    DrawerBody,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    DrawerContent,
    DrawerCloseButton,
    Text,
    HStack,
    Image,
    Box,
    Stack,
} from '@chakra-ui/react'
import { AiOutlineCluster, AiOutlineCompass, AiOutlineFundProjectionScreen, AiOutlineHome, AiOutlineLogout, AiOutlineProject } from "react-icons/ai"
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { isActive } from '../Authetication'
import { useMsal } from '@azure/msal-react'
import { NavList } from '../Layouts/NavList'



export default function SideBarDrawer({ isOpen, onOpen, onClose }) {

    const location = useLocation();
    const List = NavList(location);

   
    const navigate = useNavigate();
    const {instance} = useMsal();

    const Logout = ()=>{
        localStorage.clear("accessToken")
        localStorage.clear("ImsToken")
        instance.logoutRedirect({
            scopes: ['user.read']
        }) 
        navigate("/")
    }
    return (
        <Drawer
            isOpen={isOpen}
            placement='left'
            onClose={onClose}

        >
            <DrawerOverlay />
            <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>
                    <HStack>
                        <Image w="100px" src="./logo.jpg" />
                    </HStack>

                </DrawerHeader>

                <DrawerBody>
                    <Stack spacing={"15px"} mt="32px">

                        {
                            List?.filter(item => item.display === true)
                            .map((item, i) => (
                                <Link to={item.link}>
                                    <HStack bgColor={item.active ? "blue.blue100" : "gray.gray200"} padding={"10px"} fontFamily="body" fontSize={"14px"} rounded= "8px" fontWeight={"500"} color={item.active ? "#fff" : "black"} _hover={{ bgColor: "blue.blue100", color: "#fff" }} key={i} cursor="pointer">
                                        <Box textAlign={"center"} fontSize={"20px"} pos="relative" top="-1px">{item.icon}</Box>
                                        <Text textAlign={"center"} textTransform={"capitalize"}>{item.name}</Text>
                                    </HStack>
                                </Link>
                            ))
                        }

                        <HStack rounded= "8px" onClick={Logout} bgColor={"gray.gray200"} padding={"8px"} fontFamily="body" fontSize={"14px"} fontWeight={"500"} color={"#00000"} _hover={{ bgColor: "blue.blue100", color: "#fff"}}  cursor="pointer">
                        <Box  fontSize={"20px"} pos="relative" top="-1px"><AiOutlineLogout/></Box>
                        <Text textTransform={"capitalize"} >Logout</Text>
                       </HStack>

                    </Stack>

                </DrawerBody>

                <DrawerFooter>

                </DrawerFooter>
            </DrawerContent>
        </Drawer>

    )
}
